/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vpn_Feature_3Inputs */

const en_vpn_feature_3 = /** @type {(inputs: Vpn_Feature_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unlimited with speeds up to 500mbps`)
};

const id_vpn_feature_3 = /** @type {(inputs: Vpn_Feature_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tidak terbatas dengan kecepatan hingga 500mbps`)
};

const ms_vpn_feature_3 = /** @type {(inputs: Vpn_Feature_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tidak terhad dengan kelajuan sehingga 500mbps`)
};

const ca_vpn_feature_3 = /** @type {(inputs: Vpn_Feature_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Accés il·limitat amb velocitat fins a 500 mbps`)
};

const cs_vpn_feature_3 = /** @type {(inputs: Vpn_Feature_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rychlost až 500 Mb/s`)
};

const da_vpn_feature_3 = /** @type {(inputs: Vpn_Feature_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ubegrænset med hastigheder op til 500 mbps`)
};

const de_vpn_feature_3 = /** @type {(inputs: Vpn_Feature_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unbegrenzt mit Geschwindigkeiten bis zu 500 Mbit/s`)
};

const et_vpn_feature_3 = /** @type {(inputs: Vpn_Feature_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Piiramatu kiirusega kuni 500 mbps`)
};

const es_vpn_feature_3 = /** @type {(inputs: Vpn_Feature_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ilimitado con velocidades de hasta 500 mbps`)
};

const fr_vpn_feature_3 = /** @type {(inputs: Vpn_Feature_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Illimité jusqu’à 500 Mbit/s`)
};

const hr_vpn_feature_3 = /** @type {(inputs: Vpn_Feature_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neograničen uz brzine do 500 mbps`)
};

const it_vpn_feature_3 = /** @type {(inputs: Vpn_Feature_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Velocità illimitata fino a 500 mbps`)
};

const lv_vpn_feature_3 = /** @type {(inputs: Vpn_Feature_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neierobežoti ar ātrumu līdz 500 Mb/s`)
};

const lt_vpn_feature_3 = /** @type {(inputs: Vpn_Feature_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neribotas greitis iki 500 MBps`)
};

const hu_vpn_feature_3 = /** @type {(inputs: Vpn_Feature_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Korlátlan használat, akár 500Mbps sebesség mellett`)
};

const nl_vpn_feature_3 = /** @type {(inputs: Vpn_Feature_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Onbeperkt met snelheden tot 500 mbps`)
};

const nb_vpn_feature_3 = /** @type {(inputs: Vpn_Feature_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ubegrenset bruk med opptil 500 mbps`)
};

const pl_vpn_feature_3 = /** @type {(inputs: Vpn_Feature_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bez ograniczeń z prędkością do 500 Mb/s`)
};

const pt_vpn_feature_3 = /** @type {(inputs: Vpn_Feature_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ilimitada com velocidades de até 500mbps`)
};

const ro_vpn_feature_3 = /** @type {(inputs: Vpn_Feature_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nelimitat cu viteze de până la 500mbps`)
};

const sk_vpn_feature_3 = /** @type {(inputs: Vpn_Feature_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neobmedzené s rýchlosťou až do 500 Mb/s`)
};

const sl_vpn_feature_3 = /** @type {(inputs: Vpn_Feature_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neomejeno s hitrostmi do 500 mbps`)
};

const fi_vpn_feature_3 = /** @type {(inputs: Vpn_Feature_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rajoittamaton jopa 500 mbps nopeuksilla`)
};

const sv_vpn_feature_3 = /** @type {(inputs: Vpn_Feature_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Obegränsad med hastigheter på upp till 500 mps`)
};

const vi_vpn_feature_3 = /** @type {(inputs: Vpn_Feature_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Không giới hạn, tốc độ lên đến 500mbps`)
};

const tr_vpn_feature_3 = /** @type {(inputs: Vpn_Feature_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`500mbps'ye kadar hızlarla sınırsız`)
};

const el_vpn_feature_3 = /** @type {(inputs: Vpn_Feature_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Απεριόριστα με ταχύτητες έως 500mbps`)
};

const bg_vpn_feature_3 = /** @type {(inputs: Vpn_Feature_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Неограничен със скорости до 500 mbps`)
};

const ru_vpn_feature_3 = /** @type {(inputs: Vpn_Feature_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Неограниченный при скорости до 500мпс`)
};

const sr_vpn_feature_3 = /** @type {(inputs: Vpn_Feature_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Неограничен уз брзине до 500 mbps`)
};

const uk_vpn_feature_3 = /** @type {(inputs: Vpn_Feature_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Необмежена швидкість до 500 Мбіт/с`)
};

const ka_vpn_feature_3 = /** @type {(inputs: Vpn_Feature_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`შეუზღუდავი 500 მბიტ/წმ-მდე სიჩქარით`)
};

const hi_vpn_feature_3 = /** @type {(inputs: Vpn_Feature_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`500mbps तक की अनलिमिटेड स्पीड `)
};

const th_vpn_feature_3 = /** @type {(inputs: Vpn_Feature_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ไม่จำกัด พร้อมความเร็วสูงสุดถึง 500 เมกะบิตต่อวินาที`)
};

const ko_vpn_feature_3 = /** @type {(inputs: Vpn_Feature_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`최대 500Mbps의 속도로 무제한 이용 가능`)
};

const zh_vpn_feature_3 = /** @type {(inputs: Vpn_Feature_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`速度不受限制，最高可达 500mbps`)
};

const zh_tw_vpn_feature_3 = /** @type {(inputs: Vpn_Feature_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`無限流量，最高速度達 500Mbps`)
};

const ja_vpn_feature_3 = /** @type {(inputs: Vpn_Feature_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最大500mbpsの速度で無制限`)
};

/**
* | output |
* | --- |
* | "Unlimited with speeds up to 500mbps" |
*
* @param {Vpn_Feature_3Inputs} inputs
* @param {{ locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }} options
* @returns {LocalizedString}
*/
export const vpn_feature_3 = /** @type {((inputs?: Vpn_Feature_3Inputs, options?: { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vpn_Feature_3Inputs, { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_vpn_feature_3(inputs)
	if (locale === "ms") return ms_vpn_feature_3(inputs)
	if (locale === "ca") return ca_vpn_feature_3(inputs)
	if (locale === "cs") return cs_vpn_feature_3(inputs)
	if (locale === "da") return da_vpn_feature_3(inputs)
	if (locale === "de") return de_vpn_feature_3(inputs)
	if (locale === "et") return et_vpn_feature_3(inputs)
	if (locale === "es") return es_vpn_feature_3(inputs)
	if (locale === "fr") return fr_vpn_feature_3(inputs)
	if (locale === "hr") return hr_vpn_feature_3(inputs)
	if (locale === "it") return it_vpn_feature_3(inputs)
	if (locale === "lv") return lv_vpn_feature_3(inputs)
	if (locale === "lt") return lt_vpn_feature_3(inputs)
	if (locale === "hu") return hu_vpn_feature_3(inputs)
	if (locale === "nl") return nl_vpn_feature_3(inputs)
	if (locale === "nb") return nb_vpn_feature_3(inputs)
	if (locale === "pl") return pl_vpn_feature_3(inputs)
	if (locale === "pt") return pt_vpn_feature_3(inputs)
	if (locale === "ro") return ro_vpn_feature_3(inputs)
	if (locale === "sk") return sk_vpn_feature_3(inputs)
	if (locale === "sl") return sl_vpn_feature_3(inputs)
	if (locale === "fi") return fi_vpn_feature_3(inputs)
	if (locale === "sv") return sv_vpn_feature_3(inputs)
	if (locale === "vi") return vi_vpn_feature_3(inputs)
	if (locale === "tr") return tr_vpn_feature_3(inputs)
	if (locale === "el") return el_vpn_feature_3(inputs)
	if (locale === "bg") return bg_vpn_feature_3(inputs)
	if (locale === "ru") return ru_vpn_feature_3(inputs)
	if (locale === "sr") return sr_vpn_feature_3(inputs)
	if (locale === "uk") return uk_vpn_feature_3(inputs)
	if (locale === "ka") return ka_vpn_feature_3(inputs)
	if (locale === "hi") return hi_vpn_feature_3(inputs)
	if (locale === "th") return th_vpn_feature_3(inputs)
	if (locale === "ko") return ko_vpn_feature_3(inputs)
	if (locale === "zh") return zh_vpn_feature_3(inputs)
	if (locale === "zh-tw") return zh_tw_vpn_feature_3(inputs)
	if (locale === "ja") return ja_vpn_feature_3(inputs)
	return en_vpn_feature_3(inputs)
});